import { Injectable } from '@angular/core';
import { finalize, Observable, Subscription } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class OneTimeTokenService {
	private token: string | null = null;
	private guid: string | null = null;
	private requestQueue: Promise<void> = Promise.resolve();

	setToken(token: string): void {
		this.token = token;
	}

	getToken(): string | null {
		return this.token;
	}

	setGuid(guid: string): void {
		this.guid = guid;
	}

	getGuid(): string | null {
		return this.guid;
	}

	serialize<T>(requestFactory: () => Observable<T>): Observable<T> {
		return new Observable<T>((subscriber) => {
			let cancelled = false;
			let requestSubscription: Subscription | null = null;
			let releaseQueue!: () => void;

			const previousRequest = this.requestQueue;
			this.requestQueue = new Promise<void>((resolve) => {
				releaseQueue = resolve;
			});

			void previousRequest.then(() => {
				if (cancelled) {
					releaseQueue();
					return;
				}

				requestSubscription = requestFactory()
					.pipe(finalize(releaseQueue))
					.subscribe(subscriber);
			});

			return () => {
				cancelled = true;
				requestSubscription?.unsubscribe();
			};
		});
	}
}
